'use strict';

module.exports = {
	viewer: 'view only',
	collaborator: 'view & edit',
	invite: 'invited'
};
